<template>
    <div id="email-panel-handler" :class="panelClasses">
        <div v-for="panel in emailPanels" :key="panel.id">
            <EmailPanel
                v-if="panel.typePanel === 'create'"
                :id="`email-panel-${panel.id}`"
                :hashPanel="panel.id"
                :isPanelMinimized="panel.isMinimized"
                :prefill="panel.prefill"
                :linkEmail="panel.email"
                :linkedType="panel.linkedType"
                :linkedId="panel.linkedId"
                :signature="panel.signature"
                :doclabel="panel.doclabel"
                :docFile="panel.docFile"
                :resendAttachments="panel.attachments"
                :description="panel.description"
                :linkedObject="panel.linkedObject"
                :resendDatas="{
                    resendSubject: panel.subject,
                    resendRecipients: panel.recipients,
                    objectid: panel.objectid,
                }"
                :template="panel.template"
                :showCustomTemplates="panel.showCustomTemplates"
                @toggle-panel-state="togglePanelState(panel)"
                @open-panel="openPanel(panel.id)"
                @close-panel="closePanel(panel.id)"
            />
            <EmailConsultPanel
                v-else-if="panel.typePanel === 'consult'"
                :id="`email-panel-${panel.id}`"
                :hashPanel="panel.id"
                :isPanelMinimized="panel.isMinimized"
                :prefill="panel.prefill"
                :linkEmail="panel.email"
                :linkedType="panel.linkedType"
                :linkedId="panel.linkedId"
                :threadId="panel.threadId"
                :messageId="panel.messageId"
                :attachments="panel.attachments"
                :description="panel.description"
                :prefillSubject="panel.subject"
                :sending_type="panel.sending_type"
                :linked_object="panel.linked_object"
                :prefillEmailTo="panel.emailTo"
                :objectid="panel.objectid"
                :isFromProvider="panel.isFromProvider"
                :readProviderThreadLink="panel.readProviderThreadLink"
                @open-panel="openPanel(panel.id)"
                @close-panel="closePanel(panel.id)"
                @toggle-panel-state="togglePanelState(panel)"
            />
            <EmailPreviewPanel
                v-else-if="panel.typePanel === 'preview'"
                :id="`email-panel-${panel.id}`"
                :hashPanel="panel.id"
                :isPanelMinimized="panel.isMinimized"
                :email="panel.email"
                :thread="panel.thread"
                @open-panel="openPanel(panel.id)"
                @close-panel="closePanel(panel.id)"
                @toggle-panel-state="togglePanelState(panel)"
            />
        </div>
    </div>
</template>
<script>
import EmailPanel from 'vcomponents/email/emailPanels/EmailPanel.vue';
import EmailConsultPanel from 'vcomponents/email/EmailConsultPanel.vue';
import generateHash from 'Helpers/hashGenerator.js';
import LocalStorage from 'Core/commons/LocalStorage';
import whitelistPagesEmailPanels from 'vcomponents/email/emailPanels/whitelistPagesEmailPanels.js';
import { createNamespacedHelpers } from 'vuex';
import EmailPreviewPanel from 'vcomponents/email/emailPanels/emailPreviewPanel/EmailPreviewPanel.vue';
const { mapGetters } = createNamespacedHelpers('corp');

const WIDTH_PANEL_MINIFIED = 300;
const GAP_BETWEEN_PANEL = 16;

export default {
    name: 'EmailPanelHandler',
    components: {
        EmailPanel,
        EmailConsultPanel,
        EmailPreviewPanel,
    },
    props: {
        limit: {
            type: Number,
            default: 3,
        },
    },
    data() {
        return {
            emailPanelsLocalStorage: null,
            typePanel: '',
            emailPanels: [],
            objectid: null,
        };
    },
    computed: {
        ...mapGetters(['corpId']),
        panelClasses() {
            return [this.isOnePanelOpened ? 'opened' : 'closed'];
        },
        isOnePanelOpened() {
            return this.emailPanels.some((panel) => !panel.isMinimized);
        },
        getSimplifiedRoute() {
            return {
                fullPath: this.$route.fullPath,
                path: this.$route.path,
                hash: this.$route.hash,
                query: this.$route.query,
                params: this.$route.params,
                name: this.$route.name,
            };
        },
    },
    watch: {
        '$route.fullPath': function () {
            this.initEmailPanels();
        },
    },
    created() {
        this.emailPanelsLocalStorage = new LocalStorage(`email_${this.corpId}`, 'panels');
        this.initEmailPanels();

        EventBus.on('emailPanel:new', this.createPanel);
        EventBus.on('emailPreviewPanel:new', this.createPreviewPanel);
        EventBus.on('emailConsultPanel:new', this.createPanelConsult);
        EventBus.on('emailPanel:resend', this.createPanelToResend);
    },
    destroyed() {
        EventBus.off('emailPanel:new', this.createPanel);
        EventBus.off('emailPreviewPanel:new', this.createPreviewPanel);
        EventBus.off('emailConsultPanel:new', this.createPanelConsult);
        EventBus.off('emailPanel:resend', this.createPanelToResend);
    },
    methods: {
        // eslint-disable-next-line vue/no-unused-properties
        createPanel(emailParams, isEmailToSend) {
            // TODO: use emailParams if necessary
            if (!this.checkIfPanelCanBeCreated()) {
                this.$pushToast({
                    type: 'informative',
                    icon: true,
                    close: true,
                    unique: true,
                    text: this.$l10n.__('La limite de panneaux ouverts simultanément est atteinte'),
                });
                return;
            }
            for (const emailPanel of this.emailPanels) {
                emailPanel.isMinimized = true;
            }
            const panelId = generateHash();

            if (isEmailToSend === true) {
                const resendEmailParams = emailParams.params[0];
                this.emailPanels.unshift({
                    id: panelId,
                    typePanel: 'create',
                    isMinimized: false,
                    prefill: false,
                    subject: resendEmailParams.email.subject,
                    description: resendEmailParams.email.description,
                    isResend: true,
                    attachments: resendEmailParams.email.attachments,
                    linkedObject: resendEmailParams.email.linked_object,
                    objectid: resendEmailParams.objectid,
                    recipients: {
                        to: resendEmailParams.email.to,
                        cc: resendEmailParams.email.cc,
                        bcc: resendEmailParams.email.bcc,
                    },
                });
            } else {
                const objectTypeMapper = {
                    document: 'document',
                    third: this.$store.getters.identity?.isCorporation ? 'company' : 'individual',
                    people: 'contact',
                    opportunity: 'opportunity',
                    company: 'company',
                    contact: 'contact',
                    individual: 'individual',
                    propdocument: 'proposal',
                };
                const linkedFromListing = {
                    id: emailParams.params[1],
                    type: objectTypeMapper[emailParams.params[0]],
                };
                this.emailPanels.unshift({
                    id: panelId,
                    typePanel: 'create',
                    isMinimized: false,
                    prefill: emailParams.params[3].checkPrefill ?? false,
                    email: emailParams.params[4] ?? '',
                    linkedType: emailParams.params[2].relatedtype ?? linkedFromListing.type,
                    linkedId: emailParams.params[2].relatedid ?? linkedFromListing.id,
                    signature: emailParams.params[5] ?? '',
                    doclabel: emailParams.params[6] ?? '',
                    docFile: emailParams?.params[7] ?? {},
                    isIndividual: this.isParticular,
                    currentUrlWhenCreated: JSON.stringify(this.getSimplifiedRoute),
                    template: emailParams.params[2].template,
                    showCustomTemplates: true,
                });
            }
            this.updateLocalStorageForEmailPanels();
        },
        createPanelToResend(oneLog) {
            this.createPanel(oneLog, true);
        },
        createPanelConsult(emailParams) {
            if (!this.checkIfPanelCanBeCreated()) {
                this.$pushToast({
                    type: 'informative',
                    icon: true,
                    close: true,
                    unique: true,
                    text: this.$l10n.__('La limite de panneaux ouverts simultanément est atteinte'),
                });
                return;
            }
            for (const emailPanel of this.emailPanels) {
                emailPanel.isMinimized = true;
            }
            const panelId = generateHash();
            this.emailPanels.unshift({
                id: panelId,
                isMinimized: false,
                threadId: emailParams.params[0].oneLog.email.threadId,
                typePanel: 'consult',
                messageId: emailParams.params[0].oneLog.objectid,
                currentUrlWhenCreated: JSON.stringify(this.getSimplifiedRoute),
                attachments: emailParams.params[0].oneLog.email.attachments,
                description: emailParams.params[0].oneLog.email.description,
                subject: emailParams.params[0].oneLog.email.subject,
                sending_type: emailParams.params[0].oneLog.email.sending_type,
                linked_object: emailParams.params[0].oneLog.email.linked_object,
                emailTo: emailParams.params[0].oneLog.email.to,
                objectid: emailParams.params[0].oneLog.objectid,
                linkedId:
                    emailParams.params[0].oneLog.linkeds && emailParams.params[0].oneLog.linkeds[0]
                        ? emailParams.params[0].oneLog.linkeds[0].id
                        : null,
                linkedType:
                    emailParams.params[0].oneLog.linkeds && emailParams.params[0].oneLog.linkeds[0]
                        ? emailParams.params[0].oneLog.linkeds[0].type
                        : null,
                isFromProvider: emailParams.params[0].oneLog.isFromProvider ?? false,
                readProviderThreadLink: emailParams.params[0].oneLog.readProviderThreadLink ?? '',
            });
            this.updateLocalStorageForEmailPanels();
        },
        // eslint-disable-next-line vue/no-unused-properties
        createPreviewPanel(dataPanel) {
            if (!this.checkIfPanelCanBeCreated()) {
                this.$pushToast({
                    type: 'informative',
                    icon: true,
                    close: true,
                    unique: true,
                    text: this.$l10n.__('La limite de panneaux ouverts simultanément est atteinte'),
                });
                return;
            }
            for (const emailPanel of this.emailPanels) {
                emailPanel.isMinimized = true;
            }
            const panelId = generateHash();
            this.emailPanels.unshift({
                id: panelId,
                typePanel: 'preview',
                isMinimized: false,
                currentUrlWhenCreated: JSON.stringify(this.getSimplifiedRoute),
                thread: dataPanel.params[0].thread ?? [],
                email: dataPanel.params[0].email,
            });
            this.updateLocalStorageForEmailPanels();
        },
        checkIfPanelCanBeCreated() {
            if (this.emailPanels.length === this.limit) {
                return false;
            }
            const emailPanelHandler = document.getElementById('email-panel-handler');
            const contentDiv = document.getElementById('sellsy_app');
            const widthTotalEmailPanelHandler =
                emailPanelHandler.offsetWidth + WIDTH_PANEL_MINIFIED + GAP_BETWEEN_PANEL;
            return widthTotalEmailPanelHandler < contentDiv.offsetWidth;
        },
        openPanel(id) {
            for (const item of this.emailPanels) {
                item.isMinimized = item.id !== id;
            }
            this.updateLocalStorageForEmailPanels();
        },
        closePanel(id) {
            this.emailPanels = this.emailPanels.filter((item) => item.id !== id);
            this.updateLocalStorageForEmailPanels();
        },
        togglePanelState(panel) {
            if (panel.isMinimized) {
                for (const item of this.emailPanels) {
                    item.isMinimized = item.id !== panel.id;
                }
            } else {
                panel.isMinimized = true;
            }
            this.updateLocalStorageForEmailPanels();
        },
        updateLocalStorageForEmailPanels() {
            const lastOpenedPanel = this.emailPanels.find((panel) => !panel.isMinimized);
            for (const panel of this.emailPanels) {
                if (panel.id !== lastOpenedPanel?.id) {
                    panel.isMinimized = true;
                }
            }
            if (lastOpenedPanel) {
                this.emailPanels = this.emailPanels.filter(
                    (panel) => panel.id !== lastOpenedPanel.id,
                );
                this.emailPanels.unshift(lastOpenedPanel);
            }
            this.emailPanelsLocalStorage.set(this.emailPanels);
        },
        initEmailPanels() {
            if (this.checkUrlMatching()) {
                this.emailPanels = this.emailPanelsLocalStorage.get() ?? [];
            } else {
                this.emailPanels = [];
            }
        },
        checkUrlMatching() {
            const url = this.$route.fullPath.toLowerCase();
            for (const page of whitelistPagesEmailPanels) {
                if (url.startsWith(page.toLowerCase())) {
                    return true;
                }
            }
            return false;
        },
    },
};
</script>

<style lang="scss">
#email-panel-handler {
    bottom: 0;
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-end;
    gap: var(--spacing-3);
    position: fixed;
    right: 0;
    z-index: 1000;

    &.opened {
        margin-right: 0;
    }
    &.closed {
        margin-right: 48px;
    }

    .compass-panel.is-closed {
        width: 220px;
        right: auto;
    }
}
</style>
